<template>
	<v-row>
		<v-col lg="3">
			<admin-dashboard-main />
		</v-col>

		<v-col v-if="$vuetify.breakpoint.lgAndUp">
			<admin-dashboard-big-calendar v-if="$vuetify.breakpoint.lgAndUp" />
		</v-col>
	</v-row>
</template>

<script>
//import DashboardSidebar from "@/components/ui/DashboardSidebar";
import AdminDashboardMain from '@/components/ui/dashboard/admin/AdminDashboardMain';
import AdminDashboardBigCalendar from '@/components/ui/dashboard/admin/AdminDashboardBigCalendar';
//import { Calendar } from "dayspan";
import router from '@/router';
import { setImpersonatedUser } from '@utils';

export default {
	name: 'AdminDashboard',
	components: {
		AdminDashboardMain,
		AdminDashboardBigCalendar,
	},
	props: {
		uID: {
			type: String,
			default: null,
		},
		userType: {
			type: String,
			default: null,
		},
	},
	async mounted() {
		if (this.uID !== null && this.uID !== '' && this.uID !== undefined) {
			if (this.userType !== null && this.userType !== '' && this.userType !== undefined && this.userType === 'professional') {
				const success = await setImpersonatedUser('locum', this.uID);
				if (!success) {
					return alert('User not found');
				}
				router.push('/locum/dashboard');
			} else if (this.userType !== null && this.userType !== '' && this.userType !== undefined && this.userType === 'company') {
				const success = await setImpersonatedUser('practice', this.uID);
				if (!success) {
					return alert('User not found');
				}
				router.push('/practice/dashboard');
			} else {
				console.error('No User Type specified');
			}
		}
	},
};
</script>

<style>
* {
	text-transform: none !important;
}
</style>
